function normalizeOptionId(value) {
  return String(value ?? "").trim();
}

function getOptionItemsCount(option) {
  return Array.isArray(option?.items) ? option.items.length : 0;
}

export function resolvePendingAutoOpenFoodPickerOptionIdForNewOption({
  previousOptionCount = 0,
  options = [],
  shouldAutoOpenNewOption = false,
}) {
  if (!shouldAutoOpenNewOption || !Array.isArray(options)) {
    return null;
  }

  if (options.length <= previousOptionCount) {
    return null;
  }

  const appendedOption = options[options.length - 1] ?? null;
  const optionId = normalizeOptionId(appendedOption?.id);
  if (!optionId || getOptionItemsCount(appendedOption) > 0) {
    return null;
  }

  return optionId;
}

export function shouldAutoOpenPendingFoodPicker({
  pendingOptionId = null,
  selectedOptionId = "",
  option = null,
  shouldRenderMealBody = false,
}) {
  const normalizedPendingOptionId = normalizeOptionId(pendingOptionId);
  const normalizedSelectedOptionId = normalizeOptionId(selectedOptionId);
  const normalizedOptionId = normalizeOptionId(option?.id);

  if (
    !shouldRenderMealBody ||
    !normalizedPendingOptionId ||
    normalizedSelectedOptionId !== normalizedPendingOptionId ||
    normalizedOptionId !== normalizedPendingOptionId
  ) {
    return false;
  }

  return getOptionItemsCount(option) === 0;
}
